import Quill from 'quill'
import { insertBlot } from '../components/editor/tools'
import { getOnlineImgs } from '../api/index'

function convert(str: string) {
  return str.replace('_ques_', '?').replace('_and_', '&')
}

type ToolbarCallback = {
  editor: Quill
  idx: number
  paramsValue: string
}

const toolbarAction = (
  uploader: HTMLInputElement,
  setShowMenuBox: (p: MenuType) => void,
  insertPeople: () => Promise<void>,
  insertMatter: () => Promise<void>
) => ({
  people() {
    insertPeople()
  },
  matter() {
    insertMatter()
  },
  img() {
    document.querySelector('#uploader')?.setAttribute('accept', 'image/*')
    uploader.click()
  },
  file() {
    document.querySelector('#uploader')?.setAttribute('accept', '*')
    setShowMenuBox('file')
  },
  font() {
    setShowMenuBox('font')
  },
})

const toolbarCallback = (params: ToolbarCallback) => {
  let { editor, idx, paramsValue } = params
  console.log('back idx', idx)
  return {
    people() {
      const { original_name, id, user_id } = JSON.parse(paramsValue)
      editor.insertText(idx++, ' ')
      editor.insertEmbed(idx++, 'INSERT_FILE', {
        text: convert(original_name),
        type: 'people',
        id: id || user_id,
      })
      editor.insertText(idx++, ' ')
      window.localStorage.setItem('focusIdx', idx + '')
    },
    matter() {
      const { title, ref_task_id } = JSON.parse(paramsValue)
      editor.insertText(idx++, ' ')
      editor.insertEmbed(idx++, 'INSERT_FILE', {
        text: convert(title),
        type: 'matter',
        id: ref_task_id,
      })
      editor.insertText(idx++, ' ')
      window.localStorage.setItem('focusIdx', idx + '')
    },
    img() {},
    file() {
      const files = JSON.parse(paramsValue)
      console.log('fly files', paramsValue, files)
      if (Array.isArray(files) && files[0] && files[0].file_id) {
        const handler = async (file: FlyFile, insertIdx: number) => {
          const { file_name: title, length: size, file_id: fileId } = file,
            isImg = ['jpg', 'jpeg', 'png', 'gif'].includes(
              title.split('.').pop() as string
            )
          let url = await getImgUrl()

          async function getImgUrl() {
            if (isImg) {
              const path = Object.values(await getOnlineImgs([fileId]))[0] as
                | string
                | object

              if (typeof path === 'object') {
                return './images/icon-file/icon-file-error.png'
              }
              return path
            }
            return 'Not an Image'
          }

          editor.insertEmbed(
            insertIdx,
            'INSERT_FILE',
            {
              title,
              size,
              type: isImg ? 'img' : 'file',
              from: 'flyDoc',
              fileId,
              url,
            },
            'user'
          )
        }

        insertBlot({ insertIdx: idx, files, editor, handler })
      }
    },
    font() {},
  }
}

export default {
  toolbarAction,
  toolbarCallback,
}
